import { ChatBubbleOutlineRounded, FavoriteRounded } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';

import getAvatarSrc, { handleAvatarError } from '../../../../core/getAvatarSrc';
import { MESSAGES_PATH } from '../../../../models/Paths';
import { IStrangerUser } from '../../../../models/user/IStrangerUser/IStrangerUser';
import { IStrangerUserPreview } from '../../../../models/user/IStrangerUser/IStrangerUserPreview';
import { IUser, getProfileImage } from '../../../../models/user/IUser';
import ResourceService from '../../../../services/i18n';
import useTranslation from '../../../../services/i18n/core/useTranslation';
import './MatchDialog.scss';

export interface IMatchDialogProps {
    strangerUser: IStrangerUserPreview | IStrangerUser;
    user?: IUser;

    open: boolean;
    onClose(): void;
}

export const MatchDialog = (props: IMatchDialogProps) => {
    const { strangerUser, user, open, onClose } = props;
    const history = useHistory();
    const {
        MATCH_DIALOG_TITLE,
        MATCH_DIALOG_SUBTITLE,
        MATCH_DIALOG_SUBTITLE_SECOND_LINE,
        MATCH_DIALOG_WRITE_MESSAGE,
        MATCH_DIALOG_KEEP_MATCHING,
        MATCH_DIALOG_HINT,
    } = useTranslation();

    const userImg = user ? getProfileImage(user) : undefined;
    const strangerUserImg = getProfileImage(strangerUser);

    const handleWriteMessage = () => {
        onClose();
        history.push(`${MESSAGES_PATH.replace(':id?', strangerUser.Profilid)}?openChat=true`);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="match-dialog-title"
            PaperProps={{ className: 'match-dialog__paper' }}
            // The fixed bottom navigation sits at z-index 99999.
            sx={{ zIndex: 100040 }}
        >
            <div className="match-dialog__hero" aria-hidden="true">
                <span className="match-dialog__hero-heart">
                    <FavoriteRounded />
                </span>
                <span className="match-dialog__spark match-dialog__spark--1" />
                <span className="match-dialog__spark match-dialog__spark--2" />
                <span className="match-dialog__spark match-dialog__spark--3" />
                <span className="match-dialog__mini-heart match-dialog__mini-heart--left">
                    <FavoriteRounded />
                </span>
                <span className="match-dialog__mini-heart match-dialog__mini-heart--right">
                    <FavoriteRounded />
                </span>
            </div>

            <h2 id="match-dialog-title" className="match-dialog__title">
                {MATCH_DIALOG_TITLE}
            </h2>
            <p className="match-dialog__subtitle">
                {MATCH_DIALOG_SUBTITLE}
                <br />
                {MATCH_DIALOG_SUBTITLE_SECOND_LINE}
            </p>

            <div className="match-dialog__avatars">
                <img
                    className="match-dialog__avatar match-dialog__avatar--left"
                    src={getAvatarSrc(userImg)}
                    onError={handleAvatarError}
                    alt=""
                />
                <span className="match-dialog__heart">
                    <FavoriteRounded />
                </span>
                <img
                    className="match-dialog__avatar match-dialog__avatar--right"
                    src={getAvatarSrc(strangerUserImg)}
                    onError={handleAvatarError}
                    alt={strangerUser.Username}
                />
            </div>

            <div className="match-dialog__actions">
                <button type="button" className="match-dialog__cta" onClick={handleWriteMessage}>
                    <ChatBubbleOutlineRounded />
                    <span>{MATCH_DIALOG_WRITE_MESSAGE}</span>
                </button>
                <button type="button" className="match-dialog__ghost" onClick={onClose}>
                    {MATCH_DIALOG_KEEP_MATCHING}
                </button>
            </div>

            <p className="match-dialog__hint">
                {ResourceService.replace(MATCH_DIALOG_HINT, { name: strangerUser.Username })}
            </p>
        </Dialog>
    );
};

export default MatchDialog;
